// Pure math for the timeline's hover-position readout: given where the
// pointer sits over the track (in pixels from its left edge) and the track's
// rendered width, returns the timestamp under the cursor. Clamped to the
// track's own bounds so a pointer that has strayed past either edge (e.g. a
// fast mousemove between frames) still reports a timestamp inside `range`.
export const msFromTrackX = (offsetX, width, range) => {
  if (!range || !(width > 0)) return range?.startMs ?? 0;
  const clampedX = Math.min(Math.max(offsetX, 0), width);
  const span = range.endMs - range.startMs;
  return range.startMs + (clampedX / width) * span;
};
